import { render, staticRenderFns } from "./ScreenProducts.vue?vue&type=template&id=df44e96e&scoped=true"
import script from "./ScreenProducts.vue?vue&type=script&lang=js"
export * from "./ScreenProducts.vue?vue&type=script&lang=js"
import style0 from "./ScreenProducts.vue?vue&type=style&index=0&id=df44e96e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df44e96e",
  null
  
)

export default component.exports